import gql from "graphql-tag";

export default gql`
  mutation($orderIds: [ID!], $status: String!, $comment: String) {
    updateOrderStatus(orderIds: $orderIds, status: $status, comment: $comment)
  }
`;
